import { Component, ChangeDetectorRef } from '@angular/core';
import { TextToSpeechService } from '../../common/services/text-to-speech.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-citizen',
  templateUrl: './citizen.component.html',
  styleUrl: './citizen.component.scss'
})
export class CitizenComponent {
    // The Below Code is written to Activate Text to Speech Feature for the Website , Do not Edit to Remove this..........

    private isContentLoaded: boolean = false;

    constructor(private textToSpeechService: TextToSpeechService,private router: Router,private cdr: ChangeDetectorRef) { }

    ngAfterViewInit(){
      this.listenToRouterChanges(); // listen to router changes
    }

    ngAfterViewChecked() {
      // We check after each change detection if the content has been loaded
      if (this.isContentLoaded) return; // Avoid running the code again

      this.isContentLoaded = true; // Set flag to true after checking
      setTimeout(() => {
        // Listen to Router Changes for Text to Speech Funcitonlaity.
        this.readContentOfNewComponent();
      }, 1000); // Delay to ensure content is available after rendering
    }

    private listenToRouterChanges() {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.cdr.detectChanges(); // Trigger change detection
        this.isContentLoaded = false; // Reset flag on each route change
      });
    }

    private readContentOfNewComponent() {
      // Use a timeout to ensure the component has fully loaded before accessing its content
      setTimeout(() => {
        const componentContent = document.querySelector('.component-content'); // Look for .component-content in the loaded component
        const text = componentContent.textContent.trim();

        // console.log(text);
        if (text) {
          this.textToSpeechService.speak(text);
        }
      }, 500);  // Adjust the timeout if needed based on your app's loading speed
    }
}
